import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const SlideView = () => {
  const settings = {
    // arrows: true, 
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 3000, 
  };

  return (
    <div className="relative hidden md:block">
      <Slider {...settings}>
        <div>
          <img src="/Slide1.jpg" className="w-full" alt="img" />
        </div>
        <div>
          <img src="/Slide2.jpg" className="w-full" alt="img" />
        </div>
        <div>
          <img src="/Slide3.jpg" className="w-full" alt="img" />
        </div>
      </Slider>
    </div>
  );
};

export default SlideView;
